import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Paper,
  Typography,
} from "@material-ui/core";
import { ErrorOutline, ExpandMore, Home, Refresh } from "@material-ui/icons";
import React, { useState } from "react";

export default function ErrorPage({ error }) {
  const [expanded, setExpanded] = useState(false);

  const errorLog = {
    message: error?.message || "An unexpected error occurred",
    stack: error?.stack || "",
    timestamp: new Date().toISOString(),
    requestId: "req_" + Math.random().toString(36).substring(2, 15),
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <Container maxWidth="md" style={{ paddingTop: 32, paddingBottom: 32 }}>
      <Paper
        elevation={3}
        style={{
          padding: 32,
          borderRadius: 8,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
        }}
      >
        <ErrorOutline color="error" style={{ fontSize: 80 }} />

        <Typography variant="h4" component="h1" style={{ fontWeight: "bold" }}>
          Something went wrong
        </Typography>

        <Typography
          variant="body1"
          color="textSecondary"
          style={{ maxWidth: 500 }}
        >
          We encountered an unexpected error while processing your request. Our
          team has been notified and is working to fix the issue.
        </Typography>

        <div
          style={{
            marginTop: 16,
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            "@media (min-width: 600px)": {
              flexDirection: "row",
              justifyContent: "center",
            },
          }}
        >
          <Button
            variant="contained"
            startIcon={<Refresh />}
            onClick={handleRefresh}
          >
            Try Again
          </Button>
          <Button
            variant="outlined"
            startIcon={<Home />}
            onClick={handleGoHome}
          >
            Go to Homepage
          </Button>
        </div>

        <Box style={{ width: "100%", marginTop: 16 }}>
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.03)",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="error-log-content"
              id="error-log-header"
            >
              <Typography variant="body2" color="textSecondary">
                Technical Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Paper
                variant="outlined"
                style={{
                  padding: 16,
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  fontFamily: "monospace",
                  fontSize: "0.875rem",
                  overflow: "auto",
                  textAlign: "left",
                }}
              >
                <Typography
                  variant="body2"
                  component="div"
                  style={{ marginBottom: 8, fontWeight: "bold" }}
                >
                  Error: {errorLog.message}
                </Typography>
                <Typography
                  variant="body2"
                  component="pre"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {errorLog.stack}
                </Typography>
                <Box
                  style={{
                    marginTop: 16,
                    paddingTop: 16,
                    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography variant="caption" display="block">
                    Timestamp: {errorLog.timestamp}
                  </Typography>
                  <Typography variant="caption" display="block">
                    Request ID: {errorLog.requestId}
                  </Typography>
                </Box>
              </Paper>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Paper>
    </Container>
  );
}
